module.exports = "/images/twitter.svg?d854a845f373d773e58d37304ad29a31";